module.exports = __webpack_public_path__ + "img/fabulous6.7f0709a0.svg";